import { z } from "zod";

/**
 * `contact` is one outside person's conversation with an agent over a
 * messaging channel (ARCHITECTURE §6.19): its own transcript, its own short
 * list of tools, nothing of the agent's memory or its user's apps.
 */
export const SessionKindSchema = z.enum(["main", "browser", "computer", "general", "summarizer", "contact"]);
export type SessionKind = z.infer<typeof SessionKindSchema>;

/** Which session kinds may hold a tool. */
export const ToolScopeSchema = SessionKindSchema;
export type ToolScope = z.infer<typeof ToolScopeSchema>;

export const ModelLaneSchema = z.enum(["main", "cheap"]);
export type ModelLane = z.infer<typeof ModelLaneSchema>;

export const ResourceKindSchema = z.enum(["display", "browser"]);
export type ResourceKind = z.infer<typeof ResourceKindSchema>;

/**
 * Which tier a box runs (ARCHITECTURE §6.17). `full` is the desktop box:
 * Chrome, an X server, a screen the user can watch. `lite` is the chatbot
 * box: a terminal and the files, no browser and no desktop. The tier is a
 * property of the image, not a setting inside it — a box cannot change tier
 * while running, and the two are separate containers.
 */
export const BoxProfileSchema = z.enum(["full", "lite"]);
export type BoxProfile = z.infer<typeof BoxProfileSchema>;
